import * as React from 'react';
import { connect } from 'react-redux';

// Components
import { DefaultWrapper } from '../../../components/Layout/DefaultWrapper';
import MenuOpener from '../../../components/MenuOpener';
import Footer from '../../../components/Layout/Footer';

// Screens
import Feature from './screens/Feature';
import HowWeDidItScreen from './screens/HowWeDidIt';
import BeautifullyEmotiveScreen from './screens/BeautifullyEmotive';
import ProfessionalPanelScreen from './screens/ProfessionalPanel';
import CounterScreen from './screens/Counter';
import FooterScreen from './screens/Footer';

const BridgingTheGap = () => (
  <DefaultWrapper>
    {/* menu */}
    <MenuOpener className="menu-opener" />
    {/* Screens */}
    <Feature />
    <HowWeDidItScreen />
    <BeautifullyEmotiveScreen />
    <ProfessionalPanelScreen />
    <CounterScreen />
    <FooterScreen />
    <Footer />
  </DefaultWrapper>
);

export default connect()(BridgingTheGap);



// WEBPACK FOOTER //
// ./src/pages/CaseStudies/BridgingTheGap/index.jsx